import styled from 'styled-components';

import Image from 'components/Image';
import Button from 'components/Button';

import { LOCATION_HASH_ID } from 'utils/constants';

import { BackgroundTexture } from 'styles/global';
import BREAKPOINTS from 'styles/breakpoints';
import COLORS from 'styles/colors';
import { Grid, columns } from 'styles/grid';
import TYPO, { H5, P2, weight } from 'styles/typography';

const Section = styled(Grid)`
  padding-bottom: 70px;
  padding-top: 70px;
  background-color: ${COLORS.sky};
  color: ${COLORS.forest};
  ${BackgroundTexture}

  ${BREAKPOINTS.medium`
    padding: 110px var(--gutter-side) 80px;
  `}
`;

const Content = styled.div`
  ${columns(null, 12)}
  align-self: center;
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  align-items: center;

  ${BREAKPOINTS.small`
    ${columns(8, 5)}
    align-items: flex-start;
  `}
`;

const Title = styled(H5)`
  margin-bottom: 24px;
  font-weight: ${weight.semibold};
`;

const Subtitle = styled(P2)`
  margin: 0 0 5px;
  color: ${COLORS.forestDark};
  opacity: 0.5;
`;

const Details = styled.div`
  margin-bottom: 22px;
  display: inline-block;
  vertical-align: top;
  width: 100%;

  ${BREAKPOINTS.small`
    display: block;
    width: auto;
  `}
`;

const Info = styled.span`
  ${TYPO.p3}
  display: block;
  white-space: pre-wrap;
`;

const A = styled.a`
  ${columns(null, 12)}
  margin-bottom: 54px;
  width: 320px;
  height: 320px;
  justify-self: center;
  border-radius: 100%;
  overflow: hidden;

  ${BREAKPOINTS.small`
    ${columns(null, 7)}
    margin-bottom: 0;
  `}

  ${BREAKPOINTS.medium`
    width: 430px;
    height: 430px;
  `}

  ${BREAKPOINTS.large`
    ${columns(2, 5)}
    width: 500px;
    height: 500px;
  `}
`;

const Location = ({ title, locationDetails }) => {
  const { address, phone, openingTimes, mapImage, googleMapUrl } =
    locationDetails;

  const googleMapsLink = {
    href: googleMapUrl,
    target: '_blank',
    rel: 'noreferrer',
  };
  return (
    <Section id={LOCATION_HASH_ID}>
      {mapImage?.url && (
        <A {...googleMapsLink} aria-label="View Google map">
          <Image image={mapImage} />
        </A>
      )}
      <Content>
        <Title as="h2">{title}</Title>
        <Details>
          <Subtitle>Address</Subtitle>
          <Info>{address}</Info>
          <Info>Telephone: {phone}</Info>
        </Details>
        <Details>
          <Subtitle>Opening times</Subtitle>
          <Info>{openingTimes}</Info>
        </Details>
        <Button {...googleMapsLink} outline className="w-fit">
          Get Directions
        </Button>
      </Content>
    </Section>
  );
};

export default Location;
